import { useContext } from 'react';
import { AppConfigurationContext } from '../../../hooks/useAppConfiguration';
function useBookingAppConfiguration() {
  const ctx = useContext(AppConfigurationContext);
  if (!ctx) {
    throw new Error('useBookingAppConfiguration must be used within a AppConfigurationContainer');
  }
  return ctx;
}
export { useBookingAppConfiguration };